import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ChoiceList from 'components/WMS/Desktop/ChoiceList/ChoiceList'
import {Grid} from "@mui/material";

DualChoiceList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        isSelectedFirst: PropTypes.bool,
        isSelectedSecond: PropTypes.bool
    })).isRequired,
    firstTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    secondTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    setFirstChoice: PropTypes.func.isRequired,
    setSecondChoice: PropTypes.func.isRequired
};

function DualChoiceList({ items, firstTitle, secondTitle, setFirstChoice, setSecondChoice, selectedAssociation }) {
    const [choices, setChoices] = useState(items);

    const handleSelect = (id, listType) => {
        let noSecondPlace = false
        setChoices(prevChoices => prevChoices.map(item => {
            if (item.id === id) {
                if (listType === 'first') {
                    return { ...item, isSelectedFirst: true, isSelectedSecond: false };
                } else {
                    if (item.isSelectedSecond) {
                        noSecondPlace = true
                        return { ...item, isSelectedSecond: false };
                    }
                    return { ...item, isSelectedFirst: false, isSelectedSecond: true };
                }
            } else {
                if (listType === 'first') {
                    return { ...item, isSelectedFirst: false };
                } else {
                    return { ...item, isSelectedSecond: false };
                }
            }
        }));
        if (listType === 'first') {
            setFirstChoice(id)
        } else if (false === noSecondPlace){
            setSecondChoice(id)
        } else {
            setSecondChoice(null)
        }
    };

    const firstList = choices.map(item => ({
        ...item,
        disabled: item.isSelectedSecond
    }));
    const secondList = choices.map(item => ({
        ...item,
        disabled: item.isSelectedFirst
    }));

    useEffect(() => {
        if (selectedAssociation) {
            items.map(place => {
                if (place.id === selectedAssociation.firstPlace.barcode) {
                    place.isSelectedFirst = true
                }
                if (place.id === selectedAssociation.secondPlace?.barcode) {
                    place.isSelectedSecond = true
                }
            })
        }
    }, [selectedAssociation]);

    return (
        <Grid container gap={"24px"} direction={"column"}>
            <ChoiceList
                title={firstTitle}
                choice={choices.find(choice => choice.isSelectedFirst) || null}
                setChoice={(item) => handleSelect(item.id, 'first')}
                choiceList={firstList}
                isSelect
            />
            <ChoiceList
                title={secondTitle}
                choice={choices.find(choice => choice.isSelectedSecond) || null}
                setChoice={(item) => handleSelect(item.id, 'second')}
                choiceList={secondList}
                isSelect
            />
        </Grid>
    );
}

export default DualChoiceList;

